import { CalendarClock, X } from "lucide-react"
import { useMaintenanceNotice } from "~/hooks/use-maintenance-notice"

// Scheduled maintenance bar above every Console page, logged in or not (the
// public docs too; see lib/maintenance.ts); nothing shows outside the notice's
// dates. A thin strip in the same neutral as the login notices, so it never
// reads as a lime "what's new": calendar icon, one line, no link, and an X to
// close.
//
// Rendered first in ConsoleLayout's TopBars slot, so a release announcement
// stacks under it: logged in, inside the content column (Console's sidebar is
// fixed to the top of the screen, so a full-width bar would slide under it);
// logged out, above the public docs. The login and get access screens show
// the notice as a card instead (AuthMaintenanceNotice).
export function MaintenanceBar() {
  const { maintenance, visible, dismiss } = useMaintenanceNotice()

  if (!maintenance || !visible) {
    return null
  }

  return (
    <section
      aria-label="Scheduled maintenance"
      className="relative border-b border-border bg-[#e7e9e1] text-primary"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-12 py-2.5 text-center">
        <CalendarClock
          className="hidden h-4 w-4 shrink-0 text-primary/70 sm:block"
          strokeWidth={2}
          aria-hidden="true"
        />
        <p className="text-sm leading-snug">
          {maintenance.title}. {maintenance.detail}
        </p>
      </div>

      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 text-muted-foreground hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </section>
  )
}
